/* ==========================================================================
   Tetiloa — comportements du thème (écrits de zéro, sans dépendance)
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var S = window.themeSettings || {};
  var T = window.themeStrings || {};

  function money(cents) {
    var fmt = S.moneyFormat || '{{amount}}';
    var n = (cents / 100);
    var amount = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var noDec = String(Math.round(n));
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Bandeau d'annonces (rotation sur mobile) ---------- */
  $$('[data-announce]').forEach(function (row) {
    var items = $$('.announce__item', row);
    if (items.length < 2 || !row.classList.contains('announce__row--slide')) { if (items[0]) items[0].classList.add('is-on'); return; }
    var i = 0;
    items[0].classList.add('is-on');
    var speed = (parseFloat(row.dataset.speed) || 4) * 1000;
    if (row.dataset.autoplay === 'false') return;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, speed);
  });

  /* ---------- En-tête collant ---------- */
  var header = $('[data-header]');
  if (header && header.dataset.sticky === 'on-scroll-up') {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-hidden', y > lastY && y > 200);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Tiroirs ---------- */
  function lock(on) { document.body.classList.toggle('is-locked', on); }
  function openDrawer(el) { if (!el) return; el.hidden = false; lock(true); }
  function closeDrawer(el) { if (!el) return; el.hidden = true; lock(false); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open],[data-menu-close],[data-cart-open],[data-cart-close]');
    if (!t) return;
    if (t.hasAttribute('data-menu-open')) { openDrawer($('[data-menu-drawer]')); }
    else if (t.hasAttribute('data-menu-close')) { closeDrawer($('[data-menu-drawer]')); }
    else if (t.hasAttribute('data-cart-open')) {
      var d = $('[data-cart-drawer]');
      if (d && S.cartType === 'drawer') { e.preventDefault(); refreshCart().then(function () { openDrawer(d); }); }
    } else if (t.hasAttribute('data-cart-close')) { closeDrawer($('[data-cart-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer($('[data-menu-drawer]')); closeDrawer($('[data-cart-drawer]'));
    var v = $('[data-igs-viewer]:not([hidden])'); if (v) v.querySelector('[data-igs-close]').click();
  });

  /* ---------- Panier ---------- */
  function getCart() { return fetch(S.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function updateCount(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    var foot = $('[data-cart-foot]'); if (foot) foot.hidden = cart.item_count === 0;
    var wrap = $('[data-cart-progress]');
    if (wrap && S.freeShippingThreshold > 0) {
      var left = S.freeShippingThreshold - cart.total_price;
      var pct = Math.max(0, Math.min(100, cart.total_price / S.freeShippingThreshold * 100));
      var msg = left > 0 ? (T.freeShippingMsg || '').replace('[amount]', money(left)) : (T.freeShippingDone || '');
      $('[data-cart-progress-text]', wrap).textContent = msg;
      $('[data-cart-progress-bar]', wrap).style.width = pct + '%';
    }
  }

  function refreshCart() {
    var holders = $$('[data-cart-lines]');
    if (!holders.length) return getCart().then(updateCount);
    var sectionId = $('[data-cart-drawer]') ? 'cart-drawer' : null;
    var url = sectionId ? (S.root + '?sections=cart-drawer') : (window.location.pathname + '?sections=main-cart-items');
    return Promise.all([getCart(), fetch(url).then(function (r) { return r.json(); }).catch(function () { return null; })]).then(function (res) {
      var cart = res[0], data = res[1];
      if (data) {
        var html = data['cart-drawer'] || data['main-cart-items'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-lines]', doc);
          if (fresh) holders.forEach(function (h) { h.innerHTML = fresh.innerHTML; });
        }
      }
      updateCount(cart);
    });
  }

  function changeLine(line, qty) {
    return fetch(S.cartChangeUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      var line = parseInt(q.dataset.lineQty, 10), row = q.closest('.cart-line');
      var cur = parseInt($('.qty__val', row).textContent, 10) || 1;
      changeLine(line, Math.max(0, cur + parseInt(q.dataset.delta, 10)));
      return;
    }
    var r = e.target.closest('[data-line-remove]');
    if (r) changeLine(parseInt(r.dataset.lineRemove, 10), 0);
  });

  function kachingActive() {
    return Object.keys(window).some(function (k) { return /kachingCart/i.test(k); });
  }

  /* ---------- Ajout au panier ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) return;
    e.preventDefault();
    var btns = $$('[data-atc]', form).concat($$('button[form="' + form.id + '"]'));
    btns.forEach(function (b) { b.disabled = true; });
    var fd = new FormData(form);
    $$('[form="' + form.id + '"]').forEach(function (el) {
      if (el.name && !fd.has(el.name) && !/^option-/.test(el.name) && (el.type !== 'radio' || el.checked)) fd.append(el.name, el.value);
    });
    fetch(S.cartAddUrl + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:added'));
        return refreshCart();
      })
      .then(function () {
        if (S.cartType === 'drawer' && $('[data-cart-drawer]')) { if (!kachingActive()) openDrawer($('[data-cart-drawer]')); }
        else if (S.cartType === 'page') { window.location.href = S.cartUrl; }
      })
      .catch(function (err) { alert((err && err.description) || T.cartError || 'Erreur'); })
      .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
  });

  /* ---------- Quantité ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!b) return;
    var input = $('.qty__input', b.closest('.qty__box'));
    var v = (parseInt(input.value, 10) || 1) + (b.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(1, v);
  });

  /* ---------- Fiche produit : galerie, variantes ---------- */
  $$('[data-pdp]').forEach(function (root) {
    var sid = root.dataset.sectionId;
    var variants = [];
    try { variants = JSON.parse($('[data-pdp-variants]', root.parentNode).textContent); } catch (e) { }
    var form = document.getElementById(root.dataset.formId);
    var gallery = $('[data-gallery]', root);
    var track = gallery && $('[data-gallery-track]', gallery);
    var slides = track ? $$('.gallery__slide', track) : [];
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var dots = gallery ? $$('[data-dot]', gallery) : [];
    var current = 0;

    function goTo(i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft });
      mark(i);
    }
    function mark(i) {
      current = i;
      var gp = $('[data-gallery-prev]', gallery), gn = $('[data-gallery-next]', gallery);
      if (gp) gp.classList.toggle('is-edge', i <= 0);
      if (gn) gn.classList.toggle('is-edge', i >= slides.length - 1);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i]; if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 40 });
    }
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var w = track.clientWidth; if (w) mark(Math.round(track.scrollLeft / w));
          ticking = false;
        });
      }, { passive: true });
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumb, 10)); }); });
      var tstrip = $('[data-gallery-thumbs]', gallery);
      var tp = $('[data-thumbs-prev]', gallery), tn = $('[data-thumbs-next]', gallery);
      if (tstrip && tp) tp.addEventListener('click', function () { tstrip.scrollBy({ left: -tstrip.clientWidth * .8 }); });
      if (tstrip && tn) tn.addEventListener('click', function () { tstrip.scrollBy({ left: tstrip.clientWidth * .8 }); });
      mark(current);
      dots.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.dot, 10)); }); });
    }

    function selectedOptions() {
      var vals = [];
      $$('[data-option-index]', root).forEach(function (g) {
        var c = $('input:checked', g); vals[parseInt(g.dataset.optionIndex, 10)] = c ? c.value : null;
      });
      return vals;
    }
    function findVariant() {
      var sel = selectedOptions();
      if (!sel.length) return variants[0];
      return variants.find(function (v) { return sel.every(function (o, i) { return o === null || v.options[i] === o; }); });
    }
    function setText(sel, txt) { $$(sel, root.parentNode).forEach(function (el) { el.textContent = txt; }); }
    function onVariant(forced) {
      var v = (forced && forced.id) ? forced : findVariant();
      var atcs = $$('[data-atc]', root).concat($$('button[form="' + root.dataset.formId + '"]'));
      if (!v) { atcs.forEach(function (b) { b.disabled = true; }); setText('[data-atc-label]', T.unavailable); return; }
      var idInput = $('[data-variant-id]', document); if (idInput) idInput.value = v.id;
      setText('[data-price]', money(v.price)); setText('[data-sticky-price]', money(v.price)); setText('[data-atc-price]', money(v.price));
      var sc = $('[data-sticky-compare]', root.parentNode), sb = $('[data-sticky-badge]', root.parentNode), ssel = $('[data-sticky-variant]', root.parentNode);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (sc) { sc.hidden = !onSale; sc.textContent = onSale ? money(v.compare_at_price) : ''; }
      if (sb) { sb.hidden = !onSale; if (onSale) sb.textContent = (sb.dataset.badgeText || '').replace('[percentage]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'); }
      if (ssel) ssel.value = v.id;
      var cmp = $('[data-compare-price]', root);
      if (cmp) { var sale = v.compare_at_price && v.compare_at_price > v.price; cmp.hidden = !sale; cmp.textContent = sale ? money(v.compare_at_price) : ''; var p = $('[data-price]', root); if (p) p.classList.toggle('is-sale', !!sale); }
      var badge = $('[data-sale-badge]', root);
      if (badge && v.compare_at_price > v.price) badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      atcs.forEach(function (b) { b.disabled = !v.available; });
      $$('[data-atc-label]', root).forEach(function (el) { el.textContent = v.available ? (el.dataset.label || T.addToCart || el.textContent) : T.soldOut; });
      $$('[data-option-index]', root).forEach(function (g) { var c = $('input:checked', g), l = $('[data-option-value]', g); if (c && l) l.textContent = c.value; });
      // stock
      var inv = $('[data-inventory]', root);
      if (inv) {
        var thr = parseInt(inv.dataset.threshold, 10) || 0, q = v.inventory_quantity;
        var state = !v.available ? 'out' : (v.inventory_management && q > 0 && q <= thr ? 'low' : 'in');
        inv.className = inv.className.replace(/inv--(in|low|out)/, 'inv--' + state);
      }
      if (v.featured_media && v.featured_media.id) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId == v.featured_media.id; });
        if (idx > -1) goTo(idx);
      }
      if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    $$('.vp__radio', root).forEach(function (r) { r.addEventListener('change', function () { onVariant(); }); });
    var stickySel = $('[data-sticky-variant]', root.parentNode);
    if (stickySel) stickySel.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === stickySel.value; });
      if (!v) return;
      $$('[data-option-index]', root).forEach(function (g) { var i = parseInt(g.dataset.optionIndex, 10); $$('input', g).forEach(function (inp) { inp.checked = inp.value === v.options[i]; }); });
      onVariant(v);
    });

    /* barre collante */
    var sticky = $('[data-sticky-atc]', root);
    if (sticky) {
      sticky.hidden = false;
      var always = sticky.dataset.when === 'always';
      var buy = $('[data-atc]', root);
      var update = function () {
        var show = always;
        if (!always && buy) { var r = buy.getBoundingClientRect(); show = r.bottom < 0; }
        sticky.classList.toggle('is-visible', show);
      };
      window.addEventListener('scroll', update, { passive: true }); update();
    }
  });

  /* ---------- Diaporamas génériques ---------- */
  $$('[data-slider]').forEach(function (root) {
    var track = $('[data-slider-track]', root);
    var slides = Array.prototype.slice.call(track.children);
    if (!track || !slides.length) return;
    var dotsBox = $('[data-slider-dots]', root);
    var loop = root.dataset.loop === 'true';
    function perView() { var w = slides[0].getBoundingClientRect().width; return Math.max(1, Math.round(track.clientWidth / (w || 1))); }
    function index() { return Math.round(track.scrollLeft / (slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0))); }
    function go(i) {
      var n = slides.length, pv = perView();
      if (i < 0) i = loop ? n - pv : 0; else if (i > n - pv) i = loop ? 0 : n - pv;
      track.scrollTo({ left: slides[Math.max(0, i)].offsetLeft - track.offsetLeft });
    }
    function buildDots() {
      if (!dotsBox) return;
      var pv = perView(), pages = Math.max(1, Math.ceil(slides.length / pv));
      dotsBox.innerHTML = '';
      if (pages < 2) return;
      for (var k = 0; k < pages; k++) {
        (function (k) { var b = document.createElement('button'); b.type = 'button'; b.className = 'slider__dot'; b.setAttribute('aria-label', k + 1); b.addEventListener('click', function () { go(k * pv); }); dotsBox.appendChild(b); })(k);
      }
      markDots();
    }
    function markEdges() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.classList.toggle('is-edge', track.scrollLeft <= 2);
      if (next) next.classList.toggle('is-edge', track.scrollLeft >= max);
    }
    function markDots() {
      markEdges();
      if (!dotsBox) return;
      var pv = perView(), page = Math.round(index() / pv);
      $$('.slider__dot', dotsBox).forEach(function (d, k) { d.classList.toggle('is-active', k === page); });
    }
    var prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index() - perView()); });
    if (next) next.addEventListener('click', function () { go(index() + perView()); });
    track.addEventListener('scroll', function () { requestAnimationFrame(markDots); }, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
    if (root.dataset.autoplay === 'true') {
      var timer = setInterval(function () { go(index() + perView()); }, (parseFloat(root.dataset.speed) || 5) * 1000);
      root.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
    }
  });

  /* ---------- Compte à rebours ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.end).getTime();
    var behavior = el.dataset.behavior, repeat = (parseFloat(el.dataset.repeat) || 12) * 3600000;
    var cells = {}; $$('[data-cd]', el).forEach(function (c) { cells[c.dataset.cd] = c; });
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = Date.now(), left = end - now;
      if (left <= 0) {
        if (behavior === 'hide') { el.hidden = true; return; }
        if (behavior === 'repeat') { left = repeat - ((now - end) % repeat); }
        else { var d = new Date(); d.setHours(24, 0, 0, 0); left = d - now; }
      }
      var s = Math.floor(left / 1000), days = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      if (!cells.d) h += days * 24;
      if (cells.d) cells.d.textContent = pad(days);
      if (cells.h) cells.h.textContent = pad(h);
      if (cells.m) cells.m.textContent = pad(m);
      if (cells.s) cells.s.textContent = pad(sec);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Stories ---------- */
  $$('[data-igs]').forEach(function (root) {
    var data = []; try { data = JSON.parse($('[data-igs-data]', root).textContent); } catch (e) { }
    var viewer = $('[data-igs-viewer]', root), media = $('[data-igs-media]', root), bars = $('[data-igs-bars]', root);
    var speed = (parseFloat(root.dataset.speed) || 8) * 1000, u = 0, s = 0, raf, startT, dur;
    function stop() { cancelAnimationFrame(raf); var v = $('video', media); if (v) v.pause(); }
    function close() { stop(); viewer.hidden = true; media.innerHTML = ''; lock(false); }
    function show() {
      stop();
      var user = data[u]; if (!user) return close();
      var story = user.stories[s]; if (!story) return nextUser();
      $('[data-igs-name]', root).textContent = user.name;
      $('[data-igs-time]', root).textContent = story.time || '';
      $('[data-igs-pic]', root).innerHTML = user.pic ? '<img src="' + user.pic + '" alt="">' : '';
      bars.innerHTML = user.stories.map(function (_, k) { return '<span class="igs__bar"><i style="width:' + (k < s ? '100%' : '0') + '"></i></span>'; }).join('');
      media.style.background = story.bg || '#000';
      media.innerHTML = '';
      var el;
      if (story.type === 'video') {
        el = document.createElement('video'); el.src = story.src; el.autoplay = true; el.playsInline = true; el.muted = false; el.controls = false;
        el.addEventListener('error', function () { el.muted = true; el.play(); });
        el.play && el.play().catch(function () { el.muted = true; el.play(); });
      } else { el = document.createElement('img'); el.src = story.src; el.alt = ''; }
      el.style.objectFit = story.fit === 'cover' ? 'cover' : 'contain';
      media.appendChild(el);
      var fill = $$('.igs__bar i', bars)[s];
      startT = performance.now(); dur = speed;
      function loop(now) {
        var d = (story.type === 'video' && el.duration && isFinite(el.duration)) ? el.duration * 1000 : dur;
        var p = Math.min(1, (now - startT) / d);
        if (fill) fill.style.width = (p * 100) + '%';
        if (p >= 1) return next();
        raf = requestAnimationFrame(loop);
      }
      raf = requestAnimationFrame(loop);
    }
    function next() { s++; if (s >= data[u].stories.length) return nextUser(); show(); }
    function prev() { if (s > 0) s--; else if (u > 0) { u--; s = 0; } show(); }
    function nextUser() { u++; s = 0; if (u >= data.length) return close(); show(); }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-igs-open]');
      if (o) { var id = parseInt(o.dataset.igsOpen, 10); u = Math.max(0, data.findIndex(function (d) { return d.id === id; })); s = 0; viewer.hidden = false; lock(true); show(); return; }
      if (e.target.closest('[data-igs-close]')) close();
      else if (e.target.closest('[data-igs-next]')) next();
      else if (e.target.closest('[data-igs-prev]')) prev();
      else if (e.target === viewer) close();
    });
  });

  /* ---------- Produits associés ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.dataset.url; if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = $('[data-recommendations]', doc);
      if (src && src.children.length) el.innerHTML = src.innerHTML;
    });
  });

  /* ---------- Retour en haut, préférences de cookies ---------- */
  var top = $('[data-to-top]');
  if (top) {
    top.addEventListener('click', function () { window.scrollTo({ top: 0 }); });
    window.addEventListener('scroll', function () { top.classList.toggle('is-on', window.scrollY > 600); }, { passive: true });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cookie-prefs]')) return;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && cp.showPreferences) cp.showPreferences();
  });

  /* ---------- Tri des collections ---------- */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString();
    });
  });
})();
